module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAUCAYAAAA+wTUXAAABZUlEQVRYhe2X222DMBiFT1AW6EOkTBC8Qh6iTGCXFSJEJ+CSEULJBEWoK1CYIOoDKxgmiJSHjNAaEolcCKkINEjwSUhgAzrHPv4Ng+1u/4OOIT1bwDPoTXeFYtPBAuOZjbiwk2M9e8F4dO9YIGxS+QNUnGkF7m4PUQThMgL9Oz3/BCVLbLL2CDqpV2iddDvesTPF3OEX3Ycoa8E/q2qYo2kf63cRU+Myk6LNXSJRb61PjjghkFsc5SIy07FjIzEt0KI7iAWd+dBU/7qPf4nBIJg0q7F2JHAbb4GCj6tZzqGeKFKiop/HXERfWwHsFXJ2rYBNVpi3vHKnSKHjg7rWUfgtFOgmQejk21igThGyCJuTwaLeoaJnlbxB0Y8ypF70J4GyEWFrpGc8m0UmDLbZWBnDao+JNT4qWONniL282ssb58R0aiRfi7IZlUQ+/Tgpi3C61dk1SayfQf9r2RF6012hk6Z/Aa3FcJy/JMWjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzttb1-5.png
// module id = 860
// module chunks = 0